import {getCustomerAddresses} from 'app/features/customers/redux/customerSlice'
import {hideLoader} from 'app/redux/loaderSlice'
import {FC, useEffect, useState} from 'react'
import {Modal} from 'react-bootstrap'
import {useDispatch, useSelector} from 'react-redux'
import {RootState} from 'setup'
import {changeDraftOrderBilling, setChangeShippingAddress} from '../../redux/draft/draftOrderSlice'
import {ModalHeader} from '_core/components/Modal'
import AddressList from './AddressList'

type Props = {
  onClose: any
  customerId: any
  title?: any
  selectedAddress?: any
  paymentMethodId?: string | any
}

const CustomerAddressDialog: FC<Props> = ({
  onClose,
  customerId,
  title,
  selectedAddress,
  paymentMethodId,
}) => {
  const dispatch = useDispatch()
  const [showAddAddress, setShowAddAddress] = useState(false)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [addressId, setAddressId] = useState('')

  const addressList = useSelector<RootState>(({orders}) => orders.customer.customerAddress) as any[]

  const isFetching = useSelector<RootState>(({orders}) => orders.customer.isFetching) as any

  useEffect(() => {
    if (customerId) {
      dispatch(getCustomerAddresses(customerId))
    }
  }, [dispatch, customerId])

  const handleChangeAddress = async (address: any) => {
    try {
      setIsSubmitting(true)
      if (title === 'Shipping Address') {
        dispatch(setChangeShippingAddress(address))
        onClose()
      }
      if (title === 'Billing Address') {
        await dispatch(changeDraftOrderBilling(address, paymentMethodId))
        onClose()
      }
      dispatch(hideLoader())
    } finally {
      setIsSubmitting(false)
    }
  }

  const handleAddAddress = () => {
    setShowAddAddress(true)
  }
  const handleCloseAddress = () => {
    if (showAddAddress) {
      setShowAddAddress(false)
      setAddressId('')
    } else {
      onClose()
    }
  }

  const handleSetAddress = (show: boolean, id: string) => {
    setShowAddAddress(show)
    setAddressId(id)
  }

  return (
    <Modal
      size='lg'
      id='kt_modal_create_app'
      tabIndex={-1}
      aria-hidden='true'
      dialogClassName='h-auto w-auto'
      show={true}
      centered
    >
      <ModalHeader
        title={showAddAddress && !addressId ? 'Add New Address ' : 'Address'}
        toolbar={{onClick: handleCloseAddress}}
      />
      <AddressList
        addressList={addressList}
        isFetching={isFetching}
        onClose={handleCloseAddress}
        customerId={customerId}
        onShowAddress={handleSetAddress}
        onChangeAddress={handleChangeAddress}
        checkedAddress={selectedAddress}
        address={{
          id: addressId,
          dialog: showAddAddress,
        }}
        isSubmitting={isSubmitting}
      >
        <div className='me-5'>
          <button
            type='button'
            id='btnAddPaymentCard'
            title='Add New Address'
            onClick={handleAddAddress}
            className='btn btn-secondary'
          >
            Add New Address
          </button>
        </div>
      </AddressList>
    </Modal>
  )
}

export default CustomerAddressDialog
